import Media from '../types/Media';
import { ListItem } from '../types/Post';

// One entry for the playback queue. ISRC/UPC let the player fetch the preview
// or the full song when the entry comes up, so building a queue needs no
// requests.
/** `postId` is null for music with no post yet (a list being composed): it
 *  plays, but no play is counted. */
export function mediaToQueueItem(postId: string | null, media: Media) {
  var title = media.type === 'album' ? media.album_title : media.song_title;
  return {
    postId: postId,
    title: title || '',
    artist: media.artist || '',
    artworkURL: (media.artwork_url || '').replace('{w}x{h}', '120x120'),
    catalogID: null,
    previewURL: null,
    isrc: media.isrc || null,
    upc: media.upc || null,
  };
}

// A list played from one of its items: that item, then the rest of the list
// in the order shown (`items` already in display order), the way a track in
// a playlist plays on into the next. Each entry is credited to its own item
// post, so its card shows it playing and the play counts for it. Without a
// start, or with one not in the list, it plays from the top.
export function listQueueFrom(items: ListItem[], listPostId: string, startItemId?: string) {
  var start = startItemId
    ? items.findIndex(function (item) {
        return item.id === startItemId;
      })
    : 0;
  return items
    .slice(Math.max(0, start))
    .filter(function (item) {
      return !!item.media;
    })
    .map(function (item) {
      return mediaToQueueItem(item.id || listPostId, item.media!);
    });
}
